function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import angular from 'angular';
import { AccesoDatos } from 'src/_candidato/comun/services/acceso-datos';
import './panel-cv-print.scss';
var PanelCvPrintComponentCtrl = /*#__PURE__*/function () {
  PanelCvPrintComponentCtrl.$inject = ["$element", "$log", "$timeout", "AccesoDatos"];
  function PanelCvPrintComponentCtrl($element, $log, $timeout, AccesoDatos) {
    _classCallCheck(this, PanelCvPrintComponentCtrl);
    _defineProperty(this, "$loading", false);
    _defineProperty(this, "history", {
      list: [],
      show: true
    });
    this.$element = $element;
    this.$log = $log;
    this.$timeout = $timeout;
    this.AccesoDatos = AccesoDatos;
  }
  return _createClass(PanelCvPrintComponentCtrl, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      this.$log.info('[PanelCvPrintComponentCtrl] onInit');
      this._leerCV().then(function () {
        _this.AccesoDatos.Datos_Client.tiposParaDocuemntos().then(function (responseTipos) {
          _this.statesStore = responseTipos.estados;
        });
      });
    }
  }, {
    key: "$postLink",
    value: function $postLink() {
      $('body').css('overflow', 'auto');
    }
  }, {
    key: "_leerCV",
    value: function _leerCV() {
      var _this2 = this;
      this.$loading = true;
      return this.AccesoDatos.GestionCurr_CLIENT.leerCv(this.cv.cv.form_id, this.cv.cv.idcv).then(function (reportResponse) {
        _this2.report = reportResponse;
        _this2.history.list = reportResponse.history.list;
        _this2.$loading = false;
      });
    }
  }, {
    key: "_refreshcv",
    value: function _refreshcv() {
      this.report = null;
      this._leerCV();
    }
  }, {
    key: "toggleHistory",
    value: function toggleHistory() {
      this.history.show = !this.history.show;
    }
  }]);
}();
angular.module('candidato').component('panelCvPrint', {
  bindings: {
    cv: '<'
  },
  controller: PanelCvPrintComponentCtrl,
  // templateUrl: "panel-cv-print.component.html",
  template: require('./panel-cv-print.component.html')
});